<script lang=ts>
      import { flipOpacity } from "$lib/utils/flip"
      import LocaleSwitcher from "../locale/LocaleSwitcher.svelte"
      import { getLocaleContext } from "../locale/ts/Locale.svelte"
      import Button from "../ui/Button.svelte"
      import Toggle from "../ui/Toggle.svelte"
      import { CookieText } from "./ts/CookieText"

      const locale = getLocaleContext()

      function openDetail() {
        if(!detail) return
        modalOpen = true
        return
      }

      function closeDetail() {
        if(!detail) return
        modalOpen = false
        return
      }

      async function printState() {
        onsubmit?.({
          necessary, analytics, marketing
        })
      }

      export function open() {
        flipOpacity({element: detail, flipFn: openDetail, options: { duration: 100} })
      }
  
      export function close() {
        flipOpacity({element: detail, flipFn: closeDetail })
      }

      let detail: HTMLDivElement

      let { onsubmit = undefined } = $props()

      let necessary: boolean = $state(false)
      let analytics: boolean = $state(false)
      let marketing: boolean = $state(false)

      let modalOpen = $state(false)
</script>


<div bind:this={detail} class="detail font-primary w-full h-full absolute top-0 left-0 z-[1] bg-white p-6 overflow-y-auto rounded-xl flex-col {modalOpen ? "open" : ""}">
  <div class="ml-auto border-[1px] border-black rounded-full px-2">
    <LocaleSwitcher></LocaleSwitcher>
  </div>
  <h1 class="text-xl mb-6 mt-6 text-center font-accent flex items-center justify-center">🍪 Cookies 🍪</h1>
  <p class="font-[600] my-4">{locale.ŧ(CookieText.requiredTitle)}</p>
  <Toggle bind:checked={necessary} blocked={true}>{locale.ŧ(CookieText.required)}</Toggle>

  <p class="font-[600] my-4">{locale.ŧ(CookieText.statsTitle)}</p>
  <Toggle bind:checked={analytics}>{locale.ŧ(CookieText.stats)}</Toggle>
  
  <p class="font-[600] my-4">{locale.ŧ(CookieText.marketingTitle)}</p>
  <Toggle bind:checked={marketing}>{locale.ŧ(CookieText.marketing)}</Toggle>
  
  <div class="h-12 w-full flex-shrink-0"></div>

  <div class="flex w-full flex-col mt-auto">
    <Button size="normal" type="button" onclick={() => printState()}><div class="w-full text-center">{locale.ŧ(CookieText.accept)}</div></Button>
  </div> 
</div>


<style lang=postcss>

  .detail {
    @apply opacity-0 hidden;
  }

  .detail:global(.open) {
    @apply opacity-100 flex;
  }
  
</style>
